<template>
  <!-- <div class="pb-upload"> -->
  <label class="pb-upload " :for="id" @click="focusHandler">
    <pb-input
      v-model="value"
      :id="id"
      :size="size"
      :subTitle="subTitle"
      :placeholder="placeholder"
      readOnly
    />

    <input
      ref="fileRef"
      type="file"
      class="pb-upload-input"
      accept=".jpeg, .jpg, .png, .gif, .svg"
      @change="fileHandler"
    />
    <!-- <div class="pb-upload__dropdown"></div> -->
    <!-- <div class='pb-upload__button'></div> -->
  </label>
  <!-- </div> -->
</template>
<script>
export default {
  name: "PbUpload",
  data: () => ({
    file: null
  }),
  props: {
    id: String,
    value: String,
    size: String,
    subTitle: String,
    placeholder: String,
    formdata: Boolean
  },
  methods: {
    fileHandler(ev) {
      let data = null;

      if (this.formdata) {
        let form = new FormData();
        const image = ev.target.files[0];
        form.append("upload", image);
        form.append("result_type", "url");
        data = form;
      } else {
        data = ev.target.files;
      }

      this.$emit("upload", data);
      this.$refs.fileRef.value = "";
    },

    focusHandler() {
      this.$refs.fileRef.click();
    }
  }
};
</script>
<style lang="scss">
.pb-upload {
  display: inline-block;
  width: 100%;

  input {
    cursor: pointer;
  }

  &-input {
    display: none;
  }
}
</style>
